module.exports = __webpack_public_path__ + "img/pagado_mostrador2.17fab621.png";